<template>
  <div id="userDetailModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>유저제재</b>
      </h4>
      <div class="row">
        <div class="col-sm-4">
          <h4 class="card-title text-left">제재방법</h4>
          <div class="row">
            <el-select class="select-primary" size="large" placeholder="상태" v-model="type">
              <el-option v-for="option in types" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="type === 1" class="col-sm-4">
          <h4 class="card-title text-left">시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div v-if="type === 1" class="col-sm-4">
          <h4 class="card-title text-left">종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h4 class="card-title text-left">사유</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select class="select-primary" size="large" placeholder="사유" v-model="selectedReason">
                <el-option v-for="option in reasons" class="select-primary" :value="option.key" :label="option.reason" :key="option.reason"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h4 class="card-title text-left">메모</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="사유">
                <textarea class="form-control" id="content" rows="2" v-model="description"></textarea>
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseInput, Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";
import { UserSanctionReasons } from "@/pages/User/UserSanctionReasons";

export default {
  name: "UserDetailModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
  },
  data() {
    return {
      type: 1,
      types: [
        {
          label: "이용제재",
          value: 1,
        },
        {
          label: "영구정지",
          value: 2,
        },
      ],
      selectedReason: null,
      reasons: UserSanctionReasons,
      startTime: null,
      endTime: null,
      description: null,
    };
  },
  props: {
    userId: String,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onClickConfirm: async function () {
      await this.onConfirm();
      const param = {};
      let url = "";
      if (this.reason === null || this.reason === "") {
        window.Toast.error("사유를 선택하세요");
        return;
      }
      if (this.type === 1) {
        url = `/users/${this.userId}/block`;
        param.startTime = this.startTime;
        param.endTime = this.endTime;
        if (this.startTime === null || this.startTime === "") {
          window.Toast.error("시작시간을 넣어주세요");
          return;
        }
      } else if (this.type === 2) {
        url = `/users/${this.userId}/ban`;
      }
      param.reason = this.selectedReason;
      param.description = this.description;

      return this.$axios
        .post(url, param)
        .then((res) => {
          window.Toast.success(res.data.data.message);
          this.startTime = null;
          this.endTime = null;
          this.description = null;

          this.onClickCancel();
        })
        .catch((error) => {
          window.Toast.error(error.response.data.error.message);
        });
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
  },
};
</script>
<style lang="scss">
#userDetailModal .modal-dialog {
  max-width: 400px !important;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
